import { getMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const GET_ALL_CATEGORY_LIST = 'GET_ALL_CATEGORY_LIST';
export const GET_ALL_CATEGORY_LIST_SUCCESS = 'GET_ALL_CATEGORY_LIST_SUCCESS';
export const GET_ALL_CATEGORY_LIST_FAILURE = 'GET_ALL_CATEGORY_LIST_FAILURE';

// Action Creators
export const getAllGategory = () => ({
  type: GET_ALL_CATEGORY_LIST,
});

export const getAllGategorySuccess = (users) => ({
  type: GET_ALL_CATEGORY_LIST_SUCCESS,
  payload: users,
});

export const getAllGategoryFailure = (error) => ({
  type: GET_ALL_CATEGORY_LIST_FAILURE,
  payload: error,
});

// Thunk Function
export const getAllGategoryListCallApi = (external) => {
  return async (dispatch) => {
    dispatch(getAllGategory());
    try {
      const response = await getMethodWithToken(url.getAllCategoryList);
      if (response?.status === 200 || response?.status === 201) {
        dispatch(getAllGategorySuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
      }
    } catch (error) {
      dispatch(getAllGategoryFailure(error?.message));
    }
  };
};
